import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
    Row,
    Input,
    Card,
    CardBody,
    CardTitle,
    Button,
    Modal,
    Label,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import { faLink, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { putAPI_Update_Response, API_REST_API } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Validation from '../../../../../../components/Validation';

function InvokeApi({
    reloadBotResponse,
    code,
    apiCollections,
    setIsAddMsgToFalse,
    isAdd,
    messages,
    /** Globle property id from redux */
    propertyId,
    SaveRecommenderQuestionCode,
    locale,
    apiButtons,
    viewResponse,
    historyUpdator,
    isButtonShow
}) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [requestInput, setrequestInput] = useState([]);
    const [collectionInput, setCollectionInput] = useState([]);
    const [isdeleteAllVisible, setIsdeleteAllVisible] = useState(false);
    const [invokeApiList, setInvokeApiList] = useState(apiCollections || [{
        collection: '',
        request: ''
    }]);
    const [postData, setPostData] = useState({
        GroupId: getGroupID(),
        Code: code,
        Language: `${locale === 'en' ? 'en-US' : locale}`,
        Channel: 'WebsiteDirectLine',
        PropertyId: propertyId === "-1" ? null : propertyId,
        Default: null,
        Overrides: {},
        UserName: historyUpdator
    });

    const handleInvokeList = (e, index) => {
        let lst = [...invokeApiList];
        lst[index][e.target.name] = e.target.value;
        setInvokeApiList(lst);
    };
    const toggleAll = () => {
        setIsdeleteAllVisible(!isdeleteAllVisible);
    };
    const handlerequestChange = (e) => {
        setrequestInput(e.target.value);
    };

    // request
    const handleSave = async () => {
        try {
            return await AxiosAPI({
                method: 'put',
                url: putAPI_Update_Response,
                data: postData,
            })
                .then((res) => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        setIsEditing(false);
                        if (setIsAddMsgToFalse) {
                            setIsAddMsgToFalse();
                        }
                        setTimeout(() => {
                            if (SaveRecommenderQuestionCode !== undefined) {
                                SaveRecommenderQuestionCode();
                            } else {
                                // reloadBotResponse();
                            }
                        }, 1000);
                    }
                })
                .finally(

            );
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        setPostData((pre) => {
            if (apiButtons !== undefined && apiButtons.length > 0) {
                let buttons = [];
                buttons = apiButtons.map((button, index) => {
                    return { text: button.query.buttonText, value: button.query.code };
                });
                return {
                    ...pre,
                    Default: {
                        Messages: messages,
                        ApiCollection: invokeApiList,
                        apiButtons: buttons
                    },
                };
            } else {
                return {
                    ...pre,
                    Default: {
                        Messages: messages,
                        ApiCollection: invokeApiList
                    },
                };
            }
        });

    }, [invokeApiList]);

    useEffect(() => {
        let body = {
            channels: ['RESTAPI']
        }
        AxiosAPI({
            method: 'get',
            url: `${API_REST_API}/property/${propertyId}?group_id=${getGroupID()}`,
        })
            .then((res) => {
                if (res.data.length > 0) {
                    const restAPIIntegrationData = res.data.filter(
                        (k) => k.channel === 'RESTAPI'
                    );
                    let lst = [];
                    if (restAPIIntegrationData !== undefined) {
                        restAPIIntegrationData.map((m) => lst.push({
                            collection: m.restapiIntegration.collectionName,
                            id: m.id,
                            requestList: m.restapiIntegration.apiConfigurations.map((r) => r.requestName)
                        }));
                    }
                    setCollectionInput(lst);
                }
            })
            .catch((err) => console.log('err', err));

    }, [propertyId]);

    const handleDelete = () => {
        let data = postData;
        const arr = [...postData.Default.Messages];
        data.Default = arr;
        try {
            return AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_Response}`,
                data: data,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        if (SaveRecommenderQuestionCode !== undefined) {
                            SaveRecommenderQuestionCode();
                        } else {
                            reloadBotResponse();
                        }
                    }, 1000);
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleAddAction = () => {
        let lst = [...invokeApiList];
        lst.push({
            collection: '',
            request: ''
        });
        setInvokeApiList(lst);
    }

    const handleRemoveAction = (index) => {
        let lst = [...invokeApiList];
        lst = lst.filter((f, i) => i !== index);
        setInvokeApiList(lst);
    }

    const handleCancel = () => {
        setIsEditing(false);
        if (setIsAddMsgToFalse) {
            setIsAddMsgToFalse();
        }
    };

    const Editing = () => {
        return (
            <Fragment>
                <CardTitle>
                    <Row>
                        <Colxx xxs="6">
                            <div>
                                <i className="iconsminds-plug-in"></i>
                                <span> </span>
                                <IntlMessages id="property.add-invoke-api" />
                            </div>
                        </Colxx>
                        <Colxx xxs="6">
                            <div className="float-right">
                                <Button
                                    color="secondary"
                                    className="add-button"
                                    size="xs"
                                    onClick={handleSave}
                                >
                                    Save
                                </Button>
                                <b> </b>
                                <Button
                                    color="light"
                                    className="add-button"
                                    size="xs"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Colxx>
                    </Row>
                </CardTitle>
                {(invokeApiList !== undefined && invokeApiList.length > 0) ? invokeApiList.map((m, index) =>
                    <Row>
                        <Colxx xxs="6">
                            <Label>Collection</Label>
                            <Input
                                type="select"
                                name="collection"
                                value={m?.collection}
                                onChange={(e) => handleInvokeList(e, index)}
                            >
                                <option val=""> Please Select</option>
                                {collectionInput.length > 0 && collectionInput.map(c =>
                                    <option value={c.id}>{c.collection}</option>
                                )}
                            </Input>
                        </Colxx>
                        <Colxx xxs="6">
                            <Label>Request</Label>
                            <Input
                                type="select"
                                value={m?.request}
                                name="request"
                                onChange={(e) => handleInvokeList(e, index)}
                            >
                                <option val=""> Please Select</option>
                                {(collectionInput.length > 0 && m?.collection && m.collection !== '') && collectionInput.filter(f => f.id === m?.collection).length > 0 && collectionInput.filter(f => f.id === m?.collection)[0].requestList.map(c =>
                                    <option value={c}>{c}</option>
                                )}
                            </Input>
                        </Colxx>
                    </Row>

                ) : null}

                {/* <Colxx xxs="12" style={{ marginTop: '10px' }}>
                    <Button color='primary' size="xs" onClick={handleAddAction}>+ Add Action</Button>
                </Colxx> */}
            </Fragment>
        );
    };

    const Showing = () => {
        return (
            <Fragment>
                <CardTitle>
                    <Row>
                        <Colxx xxs="8">
                            <i className="iconsminds-plug-in"></i>
                            <span> </span>
                            <IntlMessages id="property.add-invoke-api" />
                        </Colxx>
                        {viewResponse !== true && isButtonShow &&
                            <Colxx xxs="4">
                                <div className="float-right">
                                    <FontAwesomeIcon
                                        icon={faEdit}
                                        color="#90caf9"
                                        cursor="pointer"
                                        onClick={handleEdit}
                                    />
                                    <b> | </b>
                                    <FontAwesomeIcon
                                        icon={faTrashAlt}
                                        style={{ color: 'var(--theme-color-1)' }}
                                        cursor="pointer"
                                        onClick={toggleAll}
                                    />
                                </div>
                            </Colxx>
                        }
                    </Row>
                </CardTitle>
                {(invokeApiList !== undefined && invokeApiList.length > 0) ? invokeApiList.map((m, index) =>
                    <Row>
                        <Colxx xxs="12" lg="2">
                            <b>Collection:</b>
                        </Colxx>
                        <Colxx xxs="12" lg="3">
                            <span>{(collectionInput.length > 0 && m?.collection && m.collection !== '') && collectionInput.filter(f => f.id === m?.collection).length > 0 && collectionInput.filter(f => f.id === m?.collection)[0].collection}</span>
                        </Colxx>
                        <Colxx xxs="12" lg="2">
                            <b>Request:</b>
                        </Colxx>
                        <Colxx xxs="12" lg="5">
                            <span>{m?.request}</span>
                        </Colxx>
                    </Row>) : null}
                <Modal isOpen={isdeleteAllVisible} toggle={toggleAll}>
                    <ModalHeader toggle={toggleAll}>
                        <span role="img" aria-label="warning">
                            ⚠️
                        </span>
                        InvokeApi will be deleted!
                    </ModalHeader>
                    <ModalBody>
                        <Button color="danger" onClick={() => handleDelete()} size="xs">
                            Delete
                        </Button>
                        <Button
                            className="ml-2"
                            color="dark"
                            outline
                            size="xs"
                            onClick={toggleAll}
                        >
                            Cancel
                        </Button>
                    </ModalBody>
                </Modal>
            </Fragment>
        );
    };

    return (
        <Card>
            <CardBody>{isEditing || isAdd ? Editing() : Showing()}</CardBody>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Card>
    );
}

InvokeApi.propTypes = {
    code: PropTypes.string.isRequired,
    request: PropTypes.string,
    collection: PropTypes.string,
    isAdd: PropTypes.bool,
    setIsAddMsgToFalse: PropTypes.func,
};

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};

export default injectIntl(connect(mapStateToProps)(InvokeApi));
